import { Mic } from "lucide-react";
import Seo from "@/components/common/Seo";
import PageHeader from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import CTASection from "@/components/common/CTASection";
import { VIDEOS } from "@/data/content";
import { VIDEO_THUMBS } from "@/data/images";

export default function Videos() {
  return (
    <>
      <Seo
        title="Speaking"
        description="Keynotes, panels and boardroom sessions from Executive Technology Advisor Aftab Azad, on technology value, AI strategy, digital transformation and ERP."
        path="/videos"
        keywords={["Executive Technology Advisor", "AI Strategy Consultant", "Digital Transformation Advisor", "Technology Strategy Consultant", "Keynote Speaker"]}
      />
      <PageHeader
        overline="Speaking"
        titleLines={["Ideas worth the", "boardroom's time."]}
        subtitle="Keynotes, panels and private board sessions on the technology questions leadership teams are actually wrestling with, direct, senior and free of hype."
        testId="videos-header"
      />
      <section data-testid="videos-grid" className="bg-white py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <div className="grid gap-8 md:grid-cols-2">
            {VIDEOS.map((v, i) => (
              <Reveal key={v.id} delay={(i % 2) * 0.08}>
                <div data-testid={`video-${v.id}`} className="group flex h-full flex-col overflow-hidden rounded-[1.5rem] border border-slate-200 bg-surface">
                  <div className="relative flex aspect-[16/7] items-end overflow-hidden bg-navy p-6">
                    <img src={VIDEO_THUMBS[v.id]} alt={v.title} className="absolute inset-0 h-full w-full object-cover opacity-45 transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/55 to-transparent" />
                    <span className="relative inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 font-body text-xs font-semibold uppercase tracking-[0.15em] text-white backdrop-blur">
                      <Mic className="h-3.5 w-3.5" strokeWidth={2} /> Keynote &amp; panel
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-8">
                    <span className="font-body text-xs font-bold uppercase tracking-[0.2em] text-royal">{v.topic}</span>
                    <h3 className="mt-3 font-heading text-2xl font-bold leading-snug tracking-tight text-navy transition-colors group-hover:text-royal">{v.title}</h3>
                    <p className="mt-3 font-body leading-relaxed text-slate-600">{v.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTASection
        overline="Speaking enquiries"
        heading={["Invite Aftab to", "your stage or board."]}
        body="For conferences, executive offsites and private board sessions. Share the audience and the theme, and we'll shape a session that earns the room's attention."
        primary={{ label: "Enquire about speaking", to: "/contact" }}
        secondary={{ label: "Book a Strategy Session", to: "/book" }}
      />
    </>
  );
}
